export const LOCAL_STORAGE = {
  ACCESS: 'accessToken',
  REFRESH: 'refreshToken',
  AUTH: 'user'
}